import save from '../../assets/shapes_svg/roledetail/save.svg';
const SaveChangeIcon = ({click,style}) => {
    return ( 
        <>
            <div className={"companydetail__delete " + "delete__style"+style} onClick={click}>
                <img className="" src={save} alt="" />
            </div>
        </>
     );
}
 
export default SaveChangeIcon;